import { useContext } from 'react';
import { EnterInvoiceContext } from 'src/sections/enter_invoice/EnterInvoiceContext';
const useEnterInvoices = () => {
  const context = useContext(EnterInvoiceContext);
  if (!context)
    throw new Error('Enter Invoices context must be used inside EnterInvoiceContextProvider');
  return context;
};

export default useEnterInvoices;
